/* ============================================================
   KELVIN — moteur de mouvement, registre « L'AGENCE Design Studio »
   Référence : lagencedesignstudio.com (mesures dans tmp/qwen/,
   relevés et licences dans docs/SITE-QWEN.md, bloc SITE-003).

   Le site original utilise Lenis (lerp 0.1) + GSAP + ScrollTrigger.
   Ici, les MEMES effets en vanilla, pour deux raisons mesurées :
   - CLAUDE.md pose « pas de framework » ; GSAP + ScrollTrigger +
     Lenis pèsent ~90 Ko, ce script ~9 Ko ;
   - un smooth scroll global qui réécrit la position de défilement
     casse `position:sticky` (barre d'achat mobile, sous-navigation de
     collection), le scroll-snap du rail et les ancres natives. Sur une
     boutique, ce sont des fonctions de vente, pas des détails.

   Ce qui est reproduit à l'identique :
   1. le `.reveal` signature — masque clip-path inset(0 0 0 100%) -> 0
      en 1.4s power3.out, image scale(1.2)+x(80px) -> place, conteneur
      opacité 0 -> 1 en 0.3s, déclenché à « top 75 % », RÉVERSIBLE ;
   2. le « grow effect on scroll » — échelle liée à une progression
      continue 0->1, pas à un seuil binaire ;
   3. la navigation horizontale douce — chapitre épinglé, course pilotée
      par le scroll ;
   4. ~~la transition de page — voile #222222~~ RETIRÉ le 2026-09-24 : le voile
      posait deux rectangles noirs successifs au lieu d'une transition. La page
      passe maintenant par la transition de vue native du navigateur ;
   5. le défilement amorti : la valeur LUE est lissée (lerp 0.1, comme
      Lenis), le défilement natif n'est jamais touché.

   Règle tenue : sans JavaScript, rien n'est masqué et tout reste
   atteignable. Le masquage initial est conditionné à la classe
   `.la-js` posée sur <html> par theme.liquid.
   ============================================================ */
(function () {
  'use strict';

  /* Posé au moment du parse, pas dans init() : kelvin-motion.js teste ce
     drapeau pour s'effacer, et les deux scripts sont en `defer`. Qu'il soit
     chargé avant ou après, son init() ne tourne qu'au DOMContentLoaded, donc
     le drapeau est déjà là. Un seul moteur de mouvement à la fois — sinon
     `[data-ajout]` partirait en double POST /cart/add.js. */
  window.__kelvinLa = true;

  var racine = document.documentElement;
  var mediaReduit = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mediaFin = window.matchMedia('(pointer: fine)');
  var reduit = mediaReduit.matches;

  /* Lerp de Lenis, mesuré dans miga_smooth_scrolling_params : 0.1. */
  var LERP = 0.1;

  /* --- utilitaire de base : clamp + interpolation linéaire -------
     C'est le `mapRange` commun à GSAP, motion.dev et Lenis. */
  function borne(v) {
    return v < 0 ? 0 : v > 1 ? 1 : v;
  }
  function mapRange(v, inA, inB, outA, outB) {
    return outA + borne((v - inA) / (inB - inA)) * (outB - outA);
  }

  /* --- lecture amortie du scroll --------------------------------
     On lisse la VALEUR LUE, jamais le défilement lui-même : aucun
     preventDefault, aucun overflow:hidden, aucune écriture de
     scrollTop. La barre de défilement native, l'inertie iOS, le
     momentum du trackpad, le clavier et les technologies d'assistance
     restent intégralement intacts. */
  var cible = window.scrollY;
  var lisse = window.scrollY;
  var enMarche = false;

  window.addEventListener(
    'scroll',
    function () {
      cible = window.scrollY;
      if (!enMarche) {
        enMarche = true;
        requestAnimationFrame(boucle);
      }
    },
    { passive: true }
  );

  function boucle() {
    /* Sous reduced-motion, le facteur passe à 1 : la valeur lue rejoint
       la valeur réelle immédiatement, donc l'état final est affiché
       sans traînée — jamais de contenu caché. */
    lisse += (cible - lisse) * (reduit ? 1 : LERP);
    if (Math.abs(cible - lisse) < 0.4) {
      lisse = cible;
      enMarche = false;
    }

    appliquerGrow();
    appliquerChapitres();
    appliquerMorph();

    if (enMarche) requestAnimationFrame(boucle);
  }

  /* --- offsets mis en cache --------------------------------------
     getBoundingClientRect() à chaque image force un recalcul de mise
     en page. Les offsets document sont lus une fois, puis relus au
     redimensionnement et après le chargement des polices (le texte
     change de métrique quand la webfont arrive). */
  var grows = [];
  var chapitres = [];
  var panneaux = [];

  function mesurer() {
    grows = Array.prototype.map.call(
      document.querySelectorAll('[data-grow]'),
      function (el) {
        var r = el.getBoundingClientRect();
        return {
          el: el,
          top: r.top + window.scrollY,
          ampleur: parseFloat(el.getAttribute('data-grow')) || 0.08,
          decal: parseFloat(el.getAttribute('data-grow-y')) || 0
        };
      }
    );

    chapitres = Array.prototype.map.call(
      document.querySelectorAll('[data-chapitre]'),
      function (el) {
        var piste = el.querySelector('[data-piste]');
        var r = el.getBoundingClientRect();
        var course = el.offsetHeight - window.innerHeight;
        /* La largeur disponible est celle du CADRE qui contient la piste
           (le bloc collé), pas celle de la sentinelle : la sentinelle
           porte la course verticale, le cadre porte la largeur utile. */
        var cadre = piste ? piste.parentElement : el;
        return {
          el: el,
          piste: piste,
          top: r.top + window.scrollY,
          course: course > 0 ? course : 1,
          /* Distance à parcourir : ce qui dépasse du cadre visible. */
          dep: piste ? Math.max(0, piste.scrollWidth - cadre.clientWidth) : 0
        };
      }
    );

    /* Panneaux du morph de fond. Leur logique est celle du site
       original, relevée dans son handler jQuery : le panneau qui
       contient le MILIEU du viewport donne sa couleur au `body`. */
    panneaux = Array.prototype.map.call(
      document.querySelectorAll('[data-fond]'),
      function (el) {
        var r = el.getBoundingClientRect();
        return {
          top: r.top + window.scrollY,
          haut: el.offsetHeight,
          fond: el.getAttribute('data-fond')
        };
      }
    ).sort(function (a, b) {
      return a.top - b.top;
    });
  }

  /* --- grow : l'élément GRANDIT en entrant ------------------------
     Progression continue et réversible : reculer dans la page fait
     rétrécir l'élément. C'est la différence avec un simple reveal
     binaire, et c'est ce que l'attribut « Grow effect on scroll »
     d'Awwwards décrit. Amplitude par défaut 0.08 (0.92 -> 1), dans la
     plage 0.85-1.0 recommandée : au-delà, l'effet devient théâtral. */
  function appliquerGrow() {
    if (reduit) return;
    var h = window.innerHeight;
    for (var i = 0; i < grows.length; i++) {
      var g = grows[i];
      /* 0 quand le haut de l'élément touche le bas du viewport,
         1 quand il atteint 40 % de la hauteur : course de 60 % de vh. */
      var p = borne((lisse + h - g.top) / (h * 0.6));
      if (p <= 0 || p >= 1) {
        /* Hors course : on pose l'état résolu, sans écrire à chaque image. */
        if (g.etat !== p) {
          g.etat = p;
          g.el.style.transform =
            p >= 1 ? 'translate3d(0,0,0) scale(1)' : '';
        }
        continue;
      }
      var echelle = mapRange(p, 0, 1, 1 - g.ampleur, 1);
      var y = mapRange(p, 0, 1, g.decal, 0);
      g.etat = p;
      g.el.style.transform =
        'translate3d(0,' + y.toFixed(2) + 'px,0) scale(' + echelle.toFixed(4) + ')';
    }
  }

  /* --- chapitres épinglés : défilement horizontal -----------------
     La sentinelle donne la course verticale, le bloc reste collé, la
     piste translate. Le défilement natif pilote tout : la molette, le
     clavier et le tactile fonctionnent sans interception. */
  function appliquerChapitres() {
    if (reduit) return;
    for (var i = 0; i < chapitres.length; i++) {
      var c = chapitres[i];
      if (!c.piste || c.dep <= 0) continue;
      var p = borne((lisse - c.top) / c.course);
      c.piste.style.transform = 'translate3d(' + (-p * c.dep).toFixed(2) + 'px,0,0)';
      var jauge = c.el.querySelector('[data-jauge]');
      if (jauge) jauge.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
  }

  /* --- morph de fond inter-sections -------------------------------
     Reproduit le handler jQuery de leur home : le panneau qui contient
     le milieu du viewport impose sa couleur au `body`, qui mute en 1 s
     (`body{transition:background-color ease 1s}`, mesuré). Aucun
     getBoundingClientRect par image : les offsets sont en cache, la
     comparaison est arithmétique.

     Le drapeau `noir` est volontairement ignoré ici. Un fond de page
     sombre ferait disparaître le texte des sections qui ne portent pas
     leurs propres couleurs claires — c'est un piège, pas un réglage.
     Les surfaces sombres de la boutique (protocole, pied, menu, mur)
     déclarent leur propre fond opaque et n'ont pas besoin du morph. */
  var fondCourant = null;
  function appliquerMorph() {
    if (!panneaux.length) return;
    var milieu = lisse + window.innerHeight / 2;
    var trouve = null;
    for (var i = 0; i < panneaux.length; i++) {
      var p = panneaux[i];
      if (p.fond === 'noir') continue;
      if (milieu >= p.top && milieu < p.top + p.haut) {
        trouve = p.fond;
        break;
      }
    }
    if (trouve === null || trouve === fondCourant) return;
    fondCourant = trouve;
    document.body.setAttribute('data-fond', trouve);
  }

  /* --- épinglage progressif --------------------------------------
     La section des gestes est, par défaut en CSS, un simple conteneur
     à défilement horizontal natif : fonctionnelle sans JS. On ne la
     passe en chapitre épinglé que si tout est réuni — JS présent,
     mouvement autorisé, écran large, et piste qui déborde vraiment.
     Sinon l'épinglage immobiliserait une piste qui n'a rien à montrer. */
  function epingler() {
    document.querySelectorAll('[data-chapitre]').forEach(function (el) {
      /* CORRECTION mesurée au rendu. Le test portait sur
         `el.classList.contains('la-gestes')`, or `[data-chapitre]` est posé
         sur `.la-gestes__sentinelle`, un DESCENDANT de `.la-gestes` : la
         condition était toujours fausse, la classe `is-epingle` n'était
         jamais ajoutée, le bloc restait en `position:static` et la jauge
         en `display:none`. La piste était tout de même translatée par
         `appliquerChapitres`, mais sur une course fausse — la sentinelle
         sans hauteur réservée ne mesure que son contenu. D'où un défilement
         horizontal qui partait d'un coup au lieu de suivre la page.
         `closest()` remonte à la section porteuse. */
      var section = el.closest('.la-gestes');
      var eligible = !reduit && window.innerWidth > 1024 && !!section;
      if (section) section.classList.toggle('is-epingle', eligible);
    });
  }

  /* --- boucle vidéo du hero --------------------------------------
     L'attribut `autoplay` n'est volontairement PAS dans le balisage : la
     lecture est décidée ici. Trois raisons, toutes mesurables :
     1. `prefers-reduced-motion` ne peut pas empêcher un autoplay posé en
        HTML — la vidéo démarrerait avant que le script ne l'arrête ;
     2. sur téléphone, avec `preload="metadata"`, ne pas lancer la lecture
        évite de télécharger 1,49 Mo que personne ne regardera ;
     3. sans JavaScript, l'affiche (`poster`) s'affiche : une image fixe,
        jamais un fond noir.
     `play()` renvoie une promesse qui REJETTE si le navigateur bloque la
     lecture (onglet en arrière-plan, politique d'autoplay). Sans `.catch`,
     ce rejet remonte en erreur non interceptée dans la console — et mon
     propre contrôle la compterait comme un défaut du thème. */
  var videoHeroEl = null;
  var videoHeroMedia = null;

  function videoHeroAutorise() {
    if (!videoHeroEl) return false;
    if (reduit) return false;
    var grandEcranSeul = videoHeroEl.getAttribute('data-grand-ecran') === '1';
    return !grandEcranSeul || (videoHeroMedia && videoHeroMedia.matches);
  }

  function videoHeroAppliquer() {
    if (!videoHeroEl) return;
    if (videoHeroAutorise() && !document.hidden) {
      /* iOS n'autorise la lecture automatique que muette et en ligne — les deux
         attributs sont posés dans le gabarit. Avec `preload="metadata"`, le média
         peut n'avoir aucune donnée au premier appel : `play()` est alors rejeté en
         silence. On amorce donc le chargement nous-mêmes quand le tampon est vide.
         Ajouté le 2026-09-24 : la vidéo ne partait pas sur téléphone. */
      videoHeroEl.muted = true;
      videoHeroEl.setAttribute('muted', '');
      if (videoHeroEl.readyState === 0) {
        try { videoHeroEl.load(); } catch (e) {}
      }
      var p = videoHeroEl.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    } else if (!videoHeroEl.paused) {
      videoHeroEl.pause();
    }
  }

  function videoHero() {
    videoHeroEl = document.querySelector('[data-video-hero]');
    if (!videoHeroEl) return;
    videoHeroMedia = window.matchMedia('(min-width: 768px)');

    videoHeroAppliquer();

    var surMedia = function () { videoHeroAppliquer(); };
    if (videoHeroMedia.addEventListener) videoHeroMedia.addEventListener('change', surMedia);
    else if (videoHeroMedia.addListener) videoHeroMedia.addListener(surMedia);

    /* Onglet masqué : mettre en pause. Une vidéo qui tourne dans un onglet
       invisible consomme batterie et décodage pour rien. */
    document.addEventListener('visibilitychange', videoHeroAppliquer);

    /* Le média peut ne pas être prêt au moment où on demande la lecture.
       `canplay` en plus de `loadeddata` : sur iOS le premier n'arrive pas
       toujours quand le tampon se remplit après un `load()` tardif. */
    videoHeroEl.addEventListener('loadeddata', videoHeroAppliquer);
    videoHeroEl.addEventListener('canplay', videoHeroAppliquer);
    /* Dernier recours : un toucher sur la page débloque la lecture là où la
       politique d'économie d'énergie l'avait refusée. Une seule fois. */
    document.addEventListener('touchstart', function unefois() {
      document.removeEventListener('touchstart', unefois);
      videoHeroAppliquer();
    }, { passive: true, once: true });
  }

  /* --- reveal signature ------------------------------------------
     Reproduit le timeline GSAP de leur home, y compris son
     `toggleActions: "play none none reverse"` : l'élément se révèle en
     entrant, et se REMASQUE en ressortant par le bas. Un élément
     dépassé par le haut reste révélé — c'est exactement le
     comportement de l'original.
     `rootMargin: '0px 0px -25% 0px'` place le seuil de déclenchement à
     « top 75 % » du viewport, la valeur mesurée dans leur script. */
  function reveler() {
    var cibles = document.querySelectorAll('.la-reveal, .la-monte, .la-ligne');
    if (!cibles.length) return;

    /* RETIRÉ le 2026-09-24, à la demande de l'utilisateur : plus d'apparition
       au défilement. On pose l'état final tout de suite, pour tout le monde.
       On garde la classe `is-visible` plutôt que de supprimer le CSS : c'est
       elle qui porte les états définitifs (opacité 1, clip-path ouvert,
       translation nulle). L'arracher laisserait des blocs invisibles.
       L'observateur remasquait aussi les éléments en ressortant par le bas,
       ce qui rendait le retour en arrière saccadé sur téléphone. */
    cibles.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* --- magnétisme -------------------------------------------------
     Gate DUR : pointeur fin uniquement, et jamais sous reduced-motion.
     Amplitude contenue à 8 px (le skill motion borne le sucre pointeur
     à 8-12 px ; les vitrines d'agence montent à 20-40 px et c'est ce
     qui les rend fatigantes). Transform seul, aucun layout. */
  function magnetisme() {
    if (reduit || !mediaFin.matches) return;
    document.querySelectorAll('.sq-btn, .la-btn').forEach(function (el) {
      if (el.classList.contains('sq-btn--hollow') || el.classList.contains('la-btn--lien')) return;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2);
        var dy = e.clientY - (r.top + r.height / 2);
        var mx = Math.max(-8, Math.min(8, dx * 0.08));
        var my = Math.max(-8, Math.min(8, dy * 0.12));
        el.style.transform = 'translate3d(' + mx.toFixed(1) + 'px,' + my.toFixed(1) + 'px,0)';
      });
      el.addEventListener('pointerleave', function () {
        el.style.transform = '';
      });
    });
  }

  /* --- transition de page -----------------------------------------
     ⚠ La note qui était ici affirmait que « Shopify ne permet pas de poser
     l'en-tête Page-Transition, les View Transitions inter-documents ne sont
     donc pas disponibles ». **C'est périmé.** L'en-tête HTTP était le mode
     d'activation d'un essai Chrome ; la spécification l'a remplacé par
     l'at-rule CSS `@view-transition { navigation: auto }`, qui ne demande
     aucun en-tête et fonctionne sur une boutique Shopify. C'est elle qui
     porte désormais la transition, dans kelvin-lagence.css.

     Le voile #222222 qui la remplaçait est retiré le 2026-09-24 : il
     interceptait chaque clic, retardait la navigation de 320 ms derrière un
     rectangle noir, laissait le navigateur peindre la page suivante, puis en
     rejouait un second. Deux blocs sombres au lieu d'une transition. */

  function voile() {
    return document.querySelector('.la-voile');
  }

  function transitions() {
    var el = voile();
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  /* --- bandeau d'annonce rotatif ----------------------------------
     Repris de kelvin-motion.js, dont l'init est court-circuitée quand
     ce registre est actif : la fonction est ici pour qu'un seul moteur
     possède le défilement. Pause au survol et au focus, ce qui est
     aussi l'exigence WCAG 2.2.2 sur le contenu en mouvement. */
  function bandeau() {
    var pile = document.querySelector('.sq-bandeau__pile');
    if (!pile) return;
    var msgs = pile.querySelectorAll('.sq-bandeau__msg');
    if (msgs.length < 2 || reduit) return;
    var i = 0;
    var delai = parseInt(pile.dataset.rotation, 10) || 5000;
    var minuteur = null;
    function suivant() {
      msgs[i].classList.remove('is-actif');
      msgs[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-actif');
      msgs[i].removeAttribute('aria-hidden');
    }
    function demarrer() {
      if (!minuteur) minuteur = window.setInterval(suivant, delai);
    }
    function stopper() {
      window.clearInterval(minuteur);
      minuteur = null;
    }
    pile.addEventListener('pointerenter', stopper);
    pile.addEventListener('pointerleave', demarrer);
    pile.addEventListener('focusin', stopper);
    pile.addEventListener('focusout', demarrer);
    demarrer();
  }

  /* --- rail : prise en main ---------------------------------------
     Le défilement natif reste maître (molette, clavier, snap) ; le
     pointeur ajoute la traction. Snap suspendu pendant la prise,
     sinon il combat le geste. */
  function rail() {
    document.querySelectorAll('.sq-rail').forEach(function (r) {
      var pris = false, x0 = 0, g0 = 0, bouge = false;
      r.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        pris = true; bouge = false;
        x0 = e.clientX; g0 = r.scrollLeft;
        r.classList.add('is-pris');
      });
      r.addEventListener('pointermove', function (e) {
        if (!pris) return;
        var dx = e.clientX - x0;
        if (!bouge && Math.abs(dx) < 4) return;
        bouge = true;
        r.scrollLeft = g0 - dx;
      });
      function lacher() {
        if (!pris) return;
        pris = false;
        r.classList.remove('is-pris');
      }
      r.addEventListener('pointerup', lacher);
      r.addEventListener('pointercancel', lacher);
      r.addEventListener('pointerleave', lacher);
      r.addEventListener('click', function (e) {
        if (bouge) { e.preventDefault(); e.stopPropagation(); bouge = false; }
      }, true);
    });
  }

  /* --- ajout rapide depuis les cartes ------------------------------
     POST /cart/add.js puis rafraîchissement du compteur via /cart.js.
     Confirmation en pilule : jamais de modale qui coupe la lecture. */
  function ajoutRapide() {
    var boutons = document.querySelectorAll('[data-ajout]');
    if (!boutons.length) return;
    var toast = document.querySelector('.sq-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'sq-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    var minuteur = null;
    function confirmer(texte) {
      toast.textContent = texte;
      toast.classList.add('is-actif');
      window.clearTimeout(minuteur);
      minuteur = window.setTimeout(function () {
        toast.classList.remove('is-actif');
      }, 2600);
    }
    function majCompteur() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('.entete__panier').forEach(function (a) {
            a.textContent = 'panier (' + c.item_count + ')';
          });
        })
        .catch(function () {});
    }
    boutons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: btn.dataset.ajout, quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('refus');
            confirmer('ajouté au panier');
            majCompteur();
          })
          .catch(function () { confirmer('ajout impossible, voir la fiche'); })
          .then(function () { btn.disabled = false; });
      });
    });
  }

  function tri() {
    document.querySelectorAll('[data-tri]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(location.href);
        url.searchParams.set('sort_by', sel.value);
        location.href = url.toString();
      });
    });
  }

  /* --- recadrage : anti-rebond ----------------------------------- */
  var minuteurMesure = null;
  function recadrer() {
    window.clearTimeout(minuteurMesure);
    minuteurMesure = window.setTimeout(function () {
      epingler();
      mesurer();
      /* Une seule passe à vide, puis la boucle reprend la main. */
      cible = lisse = window.scrollY;
      appliquerGrow();
      appliquerChapitres();
      appliquerMorph();
    }, 140);
  }

  function init() {
    racine.classList.add('la-js');
    epingler();
    mesurer();
    appliquerMorph();
    reveler();
    videoHero();
    magnetisme();
    transitions();
    bandeau();
    rail();
    ajoutRapide();
    tri();

    window.addEventListener('resize', recadrer, { passive: true });
    /* Les polices variables changent les hauteurs de texte au chargement :
       sans cette écoute, les offsets mis en cache seraient faux. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(recadrer).catch(function () {});
    }
    window.addEventListener('load', recadrer);

    /* Le réglage peut changer en cours de session (préférence système). */
    var ecouteReduit = function () {
      reduit = mediaReduit.matches;
      epingler();
      recadrer();
      /* La préférence de mouvement peut basculer en cours de session : une
         vidéo qui continuerait à tourner après la demande d'arrêt rendrait
         la garde inopérante au moment même où elle sert. */
      videoHeroAppliquer();
    };
    if (mediaReduit.addEventListener) mediaReduit.addEventListener('change', ecouteReduit);
    else if (mediaReduit.addListener) mediaReduit.addListener(ecouteReduit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
